// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"584aca73","147":"b87a383a","196":"aa56ea0f","229":"dd7101b9","232":"77187c17","405":"0c1e6092","423":"b77624c6","484":"4854586d","501":"31c9e845","504":"2025208d","589":"1e536e88","790":"077eac7e","912":"1fb82fc7"}[chunkId] + ".chunk.js";
};